import { atom } from 'recoil';

export const shouldPrefillNameOfInsuredAtom = atom<boolean>({
    key: 'shouldPrefillNameOfInsured',
    default: false
});
